import React, { Component } from 'react'
import { Form, Input, Button } from 'antd'

function hasErrors (fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field])
}

class LoginOrganizationForm extends Component {
  state = {
    error: {
      status: false,
      message: null
    }
  }

  componentDidMount () {
    this.props.form.validateFields()
  }

  setError = (payload) => {
    this.setState({
      error: payload
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    this.props.form.validateFields((error, values) => {
      if (!error) {
        this.setError({
          status: false,
          message: null
        })

        this.props.getOrganizationByName(values.organization).then(response => {
          if (response && response.data.error) {
            this.handleReset()
            this.setError({
              status: true,
              message: 'Organization not found'// response.data.error.message
            })
            this.props.form.validateFields()
          }
        })
      }
    })
  }

  handleReset = () => {
    this.props.form.resetFields()
  }

  render () {
    const { error } = this.state
    const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form

    const organizationError = isFieldTouched('organization') && getFieldError('organization')

    return (
      <Form onSubmit={this.handleSubmit} className='form'>
        { error.status ? <div className='form__error'>{ error.message }</div> : null }
        <Form.Item validateStatus={organizationError ? 'error' : ''} help={organizationError || ''}>
          {getFieldDecorator('organization', {
            rules: [{ required: true,
              message: 'Please input your organization',
              max: 320
            }]
          })(
            <Input placeholder='Organization' name='organization' maxLength={320} />
          )}
        </Form.Item>
        <Form.Item>
          <Button type='indigo' htmlType='submit' className='login__button' loading={this.props.organization.isFetching} disabled={hasErrors(getFieldsError())}>Next</Button>
        </Form.Item>
      </Form>
    )
  }
}

export default Form.create()(LoginOrganizationForm)



// WEBPACK FOOTER //
// ./src/views/Login/components/LoginOrganizationForm/LoginOrganizationForm.jsx